
import { z } from "zod";

export const PhoneCallDirectionValues = ["INCOMING", "OUTGOING"] as const;
export const PhoneCallDirectionSchema = z.enum(PhoneCallDirectionValues);
export const PhoneCallDirection = PhoneCallDirectionSchema.enum;
export type PhoneCallDirection = (typeof PhoneCallDirectionValues)[number];
export const PhoneCallDirectionDisplayNames = { "INCOMING": "Incoming",
"OUTGOING": "Outgoing", } satisfies Record<PhoneCallDirection, string>;
